export enum LobActivityRegistrationPerimissions {
  VoRegistrations = 'vo-registrations',
  MboRegistrations = 'mbo-registrations',
  Registrations = 'registrations',
}
